export function isIframed(): boolean {
  return typeof window !== "undefined" && window.self !== window.top;
}
